import React, { Component } from 'react';
import {
  Route,
  withRouter
} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import Dashboard from './Dashboard';
import DashboardPersonal from './DashboardPersonal';
import Inquiries from './Inquiries';
import Bookings from './Bookings';
import Bookings2 from './Bookings.2';
import BookingsPersonal from './BookingsPersonal';
import Settings from './Settings';
import Invoices from './Invoices';
import Oauth from './Oauth';
import AccountSettings from '../controls/AccountSettings';
import ModalPDF from './ModalPDF';
import Importer from './Importer';
import Deactivate from './Deactivate';

@inject('userStore')
@withRouter
class Contents extends Component {
  render() {
    if (this.props.userStore.business_primary){
      return (
      	<React.Fragment>
     			<Route exact path="/" component={Dashboard}/>
          <Route path="/inquiries" render={(props) => <Inquiries location={props.location}/>}/>
          <Route path="/bookings" render={(props) => <Bookings location={props.location}/>}/>
          <Route path="/bookings-new" component={Bookings2}/>
          <Route path="/bookings-personal" render={(props) => <BookingsPersonal location={props.location}/>}/>
          <Route path="/settings" component={Settings}/>
          <Route path="/invoices" component={Invoices}/>
          <Route path="/oauth" component={Oauth}/>
          <Route exact path="/dashboard-personal" component={DashboardPersonal}/>
          <Route path="/account-settings" component={AccountSettings}/>
          <Route path="/pdf-test" component={ModalPDF}/>
          <Route path="/importer" component={Importer}/>
          <Route path="/deactivate" component={Deactivate}/>
        </React.Fragment>
      )
    } else {
      return (
      	<React.Fragment>
          <Route exact path="/" component={DashboardPersonal}/>
          <Route path="/bookings-personal" render={(props) => <BookingsPersonal location={props.location}/>}/>
          <Route path="/account-settings" component={AccountSettings}/>
        </React.Fragment>
      )
    }
  }
}

export default Contents;



// WEBPACK FOOTER //
// ./src/components/business/Contents.js